/**
 * finance-core — Xu hướng tài sản ròng theo tháng. Mỗi tháng lưu MỘT ảnh chụp (lần mở app gần nhất trong tháng
 * ghi đè); so sánh với ảnh chụp CUỐI của tháng trước. Thuần hàm, có test.
 */
export interface NetWorthPoint {
  /** yyyy-mm */
  month: string;
  /** yyyy-mm-dd của lần chụp gần nhất trong tháng */
  date: string;
  netWorth: number; liquid: number; longTerm: number; cardDebt: number; loanDebt: number;
}

export const monthKey = (d: Date): string => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
export const dateKey = (d: Date): string => `${monthKey(d)}-${String(d.getDate()).padStart(2, '0')}`;
export const netWorthDocId = (month: string): string => `networth-${month}`;

export interface NetWorthTrend {
  /** Các tháng từ cũ đến mới, ĐÃ gộp điểm hiện tại cho tháng đang xem */
  series: NetWorthPoint[];
  /** Ảnh chụp cuối của tháng gần nhất TRƯỚC tháng hiện tại (nếu có) */
  previous: NetWorthPoint | null;
  /** Chênh lệch tài sản ròng hiện tại so với `previous`; null nếu chưa có mốc so sánh */
  change: number | null;
}

export const netWorthTrend = (history: NetWorthPoint[], current: Omit<NetWorthPoint, 'month' | 'date'>, now: Date = new Date()): NetWorthTrend => {
  const month = monthKey(now);
  const byMonth = new Map(history.filter(p => p && typeof p.netWorth === 'number').map(p => [p.month, p]));
  byMonth.set(month, { ...current, month, date: dateKey(now) });
  const series = [...byMonth.values()].sort((a, b) => a.month.localeCompare(b.month));
  const previous = [...series].reverse().find(p => p.month < month) ?? null;
  return { series, previous, change: previous ? current.netWorth - previous.netWorth : null };
};
